import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop({ category, title, blurb }) {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    if (search) params.search = search;
    const t = setTimeout(() => {
      api.get("/storefront/products", { params }).then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [category, search]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-10">
        <h1 className="font-serif-display text-4xl sm:text-5xl font-bold text-[#0A0F1D] tracking-tight">{title || "Shop"}</h1>
        <p className="text-slate-500 mt-3 max-w-2xl">{blurb || "Every title is a finished, customer-ready digital product with instant download."}</p>
      </div>
      <div className="relative mb-8 max-w-md">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input data-testid="shop-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search titles..."
          className="w-full pl-11 pr-4 h-12 rounded-full border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-[#3B1F6E]/30 text-sm" />
      </div>
      {loading ? (
        <p className="text-slate-400 py-16 text-center">Loading...</p>
      ) : products.length === 0 ? (
        <p data-testid="shop-empty" className="text-slate-400 py-16 text-center">No products found.</p>
      ) : (
        <div data-testid="shop-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {products.map((p) => <ProductCard key={p.product_key} p={p} />)}
        </div>
      )}
    </div>
  );
}
